<template>
    <div>
        <DailyCheckCommentHistory :pageId="pageId" :title="title" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import DailyCheckCommentHistory from '@/app/components/DailyCheckCommentHistory.vue'

    export default {
        name: 'dailyCheckCommentHistoryIndex',
        components: {
            DailyCheckCommentHistory
        },
        computed: {
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            title: function () {
                return this.$store.getters['dailyCheckPage/dailyCheckPageName'](this.pageId)
            }
        },
        props:{
            pageId: Number
        }
    }
</script>
